import { ChangeDetectionStrategy, Component, EventEmitter, Output, AfterViewInit } from '@angular/core';

import { FocusableComponent } from '@common/modules/accessibility/focusable/focusable.component';
import { ActionButtonType } from '@common/modules/shared/components/action-button/interfaces';
import { UPLOAD_FORMAT_LINK, UPLOAD_LIMITATION_LINK } from '@common/modules/shared/links';
import { TranslateHelperService } from '@common/modules/translation/services/translate-helper.service';
import { FocusManagerService } from '@common/modules/accessibility/focus-manager.service';

import { resources } from './resources';
import { backToUpload } from './actions';

@Component({
  selector: 'vi-upload-guide',
  templateUrl: './upload-guide.component.html',
  styleUrls: ['./upload-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UploadGuideComponent extends FocusableComponent implements AfterViewInit {
  public readonly backAction = backToUpload;
  public readonly ActionButtonType = ActionButtonType;
  public readonly formatsLink = UPLOAD_FORMAT_LINK;
  public readonly limitationsLink = UPLOAD_LIMITATION_LINK;
  public resources = resources;
  public readonly UPLOAD_DIALOG_ID = 'upload-guide-dialog';

  @Output() public readonly backClicked = new EventEmitter<void>();

  constructor(private translate: TranslateHelperService, private focusManager: FocusManagerService) {
    super();

    this.translate.translateResourcesInstant(this.resources);
    this.backAction.title = this.resources.UploadGuideBackButton;
  }

  public ngAfterViewInit(): void {
    this.focusManager.focusByQuery(`#${this.UPLOAD_DIALOG_ID}`);
  }

  public backBtnClicked() {
    this.backClicked.emit();
  }

  public openLink(url) {
    window.open(url, '_blank');
  }
}
